/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Editor_Budget_DescInputs */

const en_gc_editor_budget_desc = /** @type {(inputs: Gc_Editor_Budget_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planned spending meets real life.`)
};

const zh_gc_editor_budget_desc = /** @type {(inputs: Gc_Editor_Budget_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`让预算与实际生活相遇。`)
};

/**
* | output |
* | --- |
* | "Planned spending meets real life." |
*
* @param {Gc_Editor_Budget_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_editor_budget_desc = /** @type {((inputs?: Gc_Editor_Budget_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Editor_Budget_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_editor_budget_desc(inputs)
	return zh_gc_editor_budget_desc(inputs)
});
export { gc_editor_budget_desc as "gc.editor.budget_desc" }